import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
} from "@babackapp/customer-ui/components/header";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { EnterIcon } from "@radix-ui/react-icons";
import { ArrowLeft } from "lucide-react";
import { Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import { useResolutionOptionsForm } from "../../hooks/use-resolution-options-form";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { ExchangeOptions } from "./exchange-options";
import { RefundOptions } from "./refund-options";

export function ResolutionOptions() {
  const { form, onSubmit, context, updateLineItem, lineItemId, orderId, shopId, exchangeAvailable } =
    useResolutionOptionsForm();

  const exchangeVariantId = form.watch("exchangeVariantId");
  const resolution = form.watch("resolution") as string;
  const t = useCustomText();
  const isExchangeWithoutVariant =
    context.kind === "exchange" && resolution === "exchange" && !exchangeVariantId;

  return (
    <WidgetPage>
      <Header>
        {context.kind === "exchange" ? (
          <>
            <HeaderTitle>{t("resolutionOptions.exchange.title")}</HeaderTitle>
            <HeaderDescription>
              {t("resolutionOptions.exchange.description")}
            </HeaderDescription>
          </>
        ) : (
          <>
            <HeaderTitle>{t("resolutionOptions.refund.title")}</HeaderTitle>
            <HeaderDescription>
              {t("resolutionOptions.refund.description")}
            </HeaderDescription>
          </>
        )}
      </Header>

      <form onSubmit={onSubmit}>
        {context.kind === "exchange" ? (
          <Controller
            control={form.control}
            name="resolution"
            render={({ field }) => (
              <ExchangeOptions
                exchangeVariantAvailable={exchangeAvailable}
                value={(field.value as "exchange" | "exchange-credit") ?? null}
                onChange={(v) => {
                  field.onChange(v);
                  updateLineItem(lineItemId, { resolution: v });
                  if (v !== "exchange") {
                    form.setValue("exchangeVariantId", null);
                  }
                }}
                orderId={orderId}
                lineItemId={lineItemId}
                shopId={shopId}
                exchangeVariantId={exchangeVariantId}
                onVariantChange={(variantId) =>
                  form.setValue("exchangeVariantId", variantId)
                }
              />
            )}
          />
        ) : (
          <Controller
            control={form.control}
            name="resolutionOption"
            render={({ field }) => (
              <RefundOptions value={field.value} onChange={field.onChange} />
            )}
          />
        )}

        <AnimatedButtonRow variants={{}}>
          <AnimatedButtonContainer
            layoutId="line-item-back-button"
            disableVariants={{ enter: true, exit: true }}
            layout="position"
          >
            <Link to="../resolution">
              <Button variant="secondary" type="button">
                <ArrowLeft />
                {t("common.back")}
              </Button>
            </Link>
          </AnimatedButtonContainer>
          <AnimatedButtonContainer
            layoutId="line-item-confirm-button"
            disableVariants={{ enter: true, exit: true }}
          >
            <Button type="submit" disabled={isExchangeWithoutVariant}>
              <EnterIcon />
              {t("common.confirm")}
            </Button>
          </AnimatedButtonContainer>
        </AnimatedButtonRow>
      </form>
    </WidgetPage>
  );
}
